import { useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DepositoIcertiRes022({ dossierId, onDone }) {
  const [busy, setBusy] = useState(false);

  const enviar = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setBusy(true);
    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));
    try {
      const res = await fetch(`${API}/documentos-icerti-res022/${dossierId}`, { method: "POST", body: formData });
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (data.guardados.length) toast.success(`${data.guardados.length} documento(s) guardado(s)`);
      if (data.no_reconocidos.length) toast.warning(`No reconocidos: ${data.no_reconocidos.map((n) => n.archivo).join(", ")}`);
      onDone();
    } catch {
      toast.error("Error al subir los documentos");
    } finally {
      setBusy(false);
    }
  };

  return (
    <label
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); enviar(e.dataTransfer.files); }}
      className={`flex items-center justify-center gap-2 w-full p-4 text-sm rounded-lg border-2 border-dashed border-sky-300 bg-sky-50/50 cursor-pointer transition-colors hover:bg-sky-50 ${busy ? "opacity-50 pointer-events-none" : "text-sky-700"}`}
      data-testid="deposito-icerti"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
      {busy ? "Clasificando y guardando..." : "Suelta aquí los documentos de iCerti (PDF, XML o ZIP)"}
      <input type="file" multiple accept=".pdf,.xml,.zip" className="hidden" disabled={busy} onChange={(e) => { enviar(e.target.files); e.target.value = ""; }} />
    </label>
  );
}
